/* eslint-disable no-unused-vars */
import { useLocation } from 'react-router-dom';
import {
  Avatar, Box, Container, makeStyles, Tooltip, Typography, withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import kamiNote from '../../assets/img/bot-Notas2.png';

const useStyles = makeStyles((theme) => ({
  containerHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  containerHeaderMentor: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgMentor: {
    margin: theme.spacing(0, 2, 0, 0),
  },
  containerHeaderMentorName: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '14px',
  },
  containerHeaderMentorSubname: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '10px',
  },
  containerHeaderTitle: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '18px',
  },
  containerTalentInnText: {
    textAlign: 'center',
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '18px',
  },
  note: {
    cursor: 'pointer',
    borderRadius: 50,
    background: 'white',
    boxShadow:
      'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
    border: '3px solid yellow',
  },
  kamiImg: {
    width: 40,
    borderRadius: '50%',
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    fontFamily: 'Raleway',
  },
}))(Tooltip);

function Headers({ actions, finalProject, nameContent }) {
  const classes = useStyles();
  const location = useLocation();
  const { nameCourse, practical } = location.state;
  const handleOpenNotes = () => {
    actions();
  };
  return (
    <div>
      {!finalProject ? (
        <Box className={classes.containerHeader}>
          <Box className={classes.containerHeaderMentor}>
            <Avatar
              src="https://talent-innovation.s3.us-east-2.amazonaws.com/mentors-assets/andres-mendez.jpg"
              className={classes.imgMentor}
            />
            <Box>
              <Typography className={classes.containerHeaderMentorName}>
                Andres Mendez
              </Typography>
              <Typography className={classes.containerHeaderMentorSubname}>
                Especialista
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography className={classes.containerHeaderTitle}>
              {practical ? nameCourse : nameContent}
            </Typography>
          </Box>
          { actions ? (
            <LightTooltip title="Crear nota">
              <Box className={classes.note} onClick={handleOpenNotes}>
                <img alt="kami" src={kamiNote} className={classes.kamiImg} />
              </Box>
            </LightTooltip>
          ) : (<Box />)}
        </Box>
      ) : (
        <Box>
          <Typography className={classes.containerTalentInnText}>
            Talent Innovation
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Headers;

Headers.propTypes = {
  actions: PropTypes.func,
  finalProject: PropTypes.bool,
  nameContent: PropTypes.string.isRequired,
};
Headers.defaultProps = {
  actions: null,
  finalProject: false,
};
